import { render, staticRenderFns } from "./RetrievalTableDetails.vue?vue&type=template&id=beccd7a4&scoped=true&"
import script from "./RetrievalTableDetails.vue?vue&type=script&lang=js&"
export * from "./RetrievalTableDetails.vue?vue&type=script&lang=js&"
import style0 from "./RetrievalTableDetails.vue?vue&type=style&index=0&id=beccd7a4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beccd7a4",
  null
  
)

export default component.exports